
import React, { useEffect, useState } from "react";
import { useContext } from 'react';

import { ClientContext } from '../store/client-context.jsx';

import { useNavigate } from "react-router-dom";


import { Amplify } from 'aws-amplify';
import config from '../aws-exports';
import { get } from 'aws-amplify/api';

import { useLoadingContext } from "react-router-loading";


import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Card,
} from "@aws-amplify/ui-react";

//import { Document, Page } from 'react-pdf';

//import {  Document, Page, pdfjs } from 'react-pdf';

import {  Document, Page, pdfjs } from 'react-pdf';

//import {  Document, Page } from '@react-pdf/renderer';

import { PDFDownloadLink } from '@react-pdf/renderer';


//import { Document, Page, pdfjs, PDFDownloadLink } from 'react-pdf/dist/esm/entry.webpack';




Amplify.configure(config);


const Pricing = () => {

  

    
   
    //const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
    //const url = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    //pdfjs.GlobalWorkerOptions.workerSrc = url;
    //pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    /*
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.js',
      import.meta.url,
    ).toString();
    */
   pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
   //pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
  

    const [pdfData, setCaseData] = useState();

    const [pdfData2, setCaseData2] = useState();

    const loadingContext = useLoadingContext();

    const { slctdCase  } = useContext(ClientContext);

    
    console.log ( 'pdf selectedCase=', slctdCase);
  
    const loading = async () => {
        //loading some data

    

        try {
            const restOperation = get({
              apiName: 'portalApi',
              path: '/portalapi',
              options: {
                queryParams: {
                  s3url: slctdCase[0]
                }
              },
              headers: {
                "Content-Type": "application/pdf"}
             }
            );
        
            const { body } = await restOperation.response;
    
            const blob = await body.blob();

    
            blob.arrayBuffer()
            .then( (data)=>{
                var pdfData = data; //new Uint8Array(data);

                
            
                console.log ( 'pdfData: ', pdfData );
                const view = new Uint8Array(pdfData);

              
                
                var i, j, k, len = view.length, b_str = "", b_str2 = "";
                for (i=0; i<len; i++) {
                    b_str += String.fromCharCode(view[i]);
                }

                var b_strJson = JSON.parse (b_str);


                console.log ( 'b_str: ', b_strJson);

                var dataBody = b_strJson.Body.data;

                console.log ( 'dataBody: ', dataBody);

    

                for (j=0; j<dataBody.length; j++) {
                    b_str2 += String.fromCharCode(dataBody[j]);
                }

                var pdfStr = b_str2;

                console.log ( 'pdfStr: ', pdfStr);
                
                const binaryString = window.atob(pdfStr); // Comment this if not using base64
                const bytes = new Uint8Array(binaryString.length);
                setCaseData( { data: bytes.map((byte, i) => binaryString.charCodeAt(i)) });

                let my_uint8_array = Uint8Array.from(binaryString, c => c.charCodeAt(0)); 

                let blob = new Blob([my_uint8_array], { type: 'application/pdf' });

                setCaseData2(blob);  

                loadingContext.done();
               
              })
            
              
          } catch (e) {
            console.log('GET call pdf failed: ', e.response);
          }
        
       
   
    };
    
      useEffect(() => {
        loading();
    }, []);

    
  const navigate = useNavigate();

  function returnToList (){

    navigate ( '/about');
  }

  function downloadPdf (){

    console.log ( 'download pdfData: ', pdfData2);
    
    const fileURL = 
          window.URL.createObjectURL(pdfData2);
                // Setting various property values
               let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "SamplePDF.pdf";
                alink.click();
    
                
  }

  
    return   (
        <div>
         <Document file={pdfData} onSourceError={console.error}
          onLoadError={console.error}>
       <Page    pageNumber={1}  
                scale={1.0}               
                renderAnnotationLayer={false} 
                renderTextLayer={false} />
       </Document>
       <Button onClick={() => { downloadPdf();  } } >Download PDF</Button>
       <Button onClick={returnToList}>Return to List</Button>
       </div>
       );   
    };





export default Pricing;